var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconUploadLight = function SvgIconUploadLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 33.474v-8.4h2.2v8.4c0 1.393 1.107 2.5 2.5 2.5h18.8c1.392 0 2.5-1.107 2.5-2.5v-8.4h2.2v8.4c0 2.608-2.093 4.7-4.7 4.7H14.7a4.685 4.685 0 0 1-4.7-4.7Z",
    fill: "#121619"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2 11.775v17H23v-17h2.2Z",
    fill: "#121619"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.48 10.741c.89-1.053 2.435-.907 3.298-.044l.019.02 6 6.3-1.594 1.517-5.986-6.286a.172.172 0 0 0-.09-.047 1.207 1.207 0 0 1-.037.04l-6.1 6.3-1.58-1.531 6.07-6.269Z",
    fill: "#121619"
  })));
};
export default SvgIconUploadLight;